app.controller("EditScoreController", ["$scope", "$uibModalInstance", "ProgramService", "Subject", "Lecturer", "Selection", "StaticData", "student", 'subject', "toastr",
    function ($scope, $uibModalInstance, ProgramService, Subject, Lecturer, Selection, StaticData, student, subject, toastr) {
        $scope.selection = subject;
        $scope.credits = subject.credits;
        $scope.score = subject.score;
        $scope.chosenProgram = null;
        $scope.selectionState = subject.selectionState;
        $scope.name = subject.name;
        $scope.state = subject.state;
        $scope.passed = subject.state === 'passed';
        $scope.chosenSubject = subject.subjectWrapper;
        $scope.subjectWrapper = subject.subjectWrapper ? subject.subjectWrapper._id : null;
        $scope.subject = subject.subject ? subject.subject._id : null;
        $scope.lecturers = subject.lecturers || [];
        $scope.hasLecturers = subject.hasLecturers;
        loadProgram();

        function resultGen(val) {
            val = $scope.score;
            $scope.result = 'F';
            if (!$scope.passed) {
                return;
            }

            if (val > 90) $scope.result = 'A';
            else if (val > 80) $scope.result = 'B';
            else if (val > 70) $scope.result = 'C';
            else if (val > 60) $scope.result = 'D';
            else if (val > 50) $scope.result = 'E';
        }

        $scope.$watch('score', resultGen);
        $scope.$watch('passed', resultGen);
        $scope.$watch('lecturer', function (val) {
            if (val && val._id) {
                $scope.lecturers.push(val.user.firstName + ' ' + val.user.lastName);
                $scope.lecturer = null;
            }
        }, true);

        StaticData.getItemsByKey("subject_states").then(function (states) {
            if($scope.selection.confessed){
                states = states.filter(function(state){return state._id!=="current"});
            }
            $scope.states = [{name: "სტატუსი"}].concat(states);
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        function loadProgram() {
            if (student.program) {
                ProgramService.fetchOne(student.program._id).then(function (data) {
                    $scope.chosenProgram = data;
                    // +4 allows selections beyond the program length
                    $scope.semesters = _.range(1, data.semesters + 5);
                    $scope.semester = subject.semester;
                })
            }
        }

        $scope.getSubjectWrappers = function (name) {
            return Subject.wrappersList({
                query: name,
                program: $scope.chosenProgram._id
            }).then(function (data) {
                return data.docs
            });
        };

        $scope.getLecturers = function (name) {
            return Lecturer.list({
                query: name
            }).then(function (data) {
                return data.docs
            });
        };

        $scope.edit = function () {
            var subjectEdit = {
                selection: $scope.selection._id,
                semester: $scope.semester,
                name: $scope.name,
                subjectWrapper: $scope.chosenSubject ? $scope.chosenSubject._id : $scope.subjectWrapper,
                subject: $scope.chosenSubject && $scope.chosenSubject.subject ? $scope.chosenSubject.subject._id : $scope.subject,
                state: $scope.state,
                lecturers: $scope.lecturers,
                result: $scope.result
            };

            if ($scope.state !== 'current') {
                subjectEdit.score = $scope.score;
                subjectEdit.credits = $scope.credits;
            }

            Selection.editSubjectSelection(subjectEdit).then(function () {
                toastr.success('', 'შეფასება რედაქტირებულია');
                $uibModalInstance.dismiss();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
